import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const useAuthStore = create(
    persist(
        (set, get) => ({
            user: null,
            token: null,
            isLoggedIn: false,

            // Set user after login
            setUser: (user, token) => {
                localStorage.setItem('token', token);
                localStorage.setItem('user', JSON.stringify(user));
                set({ user, token, isLoggedIn: true });
            },

            // Update user data
            updateUser: (userData) => {
                const { user } = get();
                const updated = { ...user, ...userData };
                localStorage.setItem('user', JSON.stringify(updated));
                set({ user: updated });
            },

            // Logout
            logout: () => {
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                localStorage.removeItem('activeTab');
                set({ user: null, token: null, isLoggedIn: false });
            },

            // Initialize from localStorage
            initialize: () => {
                const token = localStorage.getItem('token');
                const userStr = localStorage.getItem('user');

                if (token && userStr) {
                    try {
                        const user = JSON.parse(userStr);
                        set({ user, token, isLoggedIn: true });
                    } catch (e) {
                        console.error('Failed to parse stored user:', e);
                    }
                }
            },
        }),
        {
            name: 'auth-storage',
            partialize: (state) => ({ user: state.user, token: state.token }),
        }
    )
);

export default useAuthStore;
